import { type Enum } from '@webapp/infrastructure/types/Enum'

export const GlobalSearchResultStatuses = {
  PENDING_APPROVAL: 'pending-approval',
  APPROVED: 'approved',
  DENIED: 'denied',
  PURCHASED: 'purchased',
  RECEIVED: 'received',
  OPEN: 'open',
  REOPENED: 'reopened',
  CANCELLED: 'cancelled',
  CLOSED: 'closed',
  PAID: 'paid',
  DRAFT: 'draft',
  SCHEDULED: 'scheduled',
  PROCESSING: 'processing',
  FAILED: 'failed',
  INACTIVE: 'inactive',
  ACTIVE: 'active',
  EXPIRED: 'expired',
  TERMINATED: 'terminated',
  AI_DRAFT: 'ai-draft',
  AI_DRAFT_ERROR: 'ai-draft-error',
} as const

export type GlobalSearchResultStatusEnum = Enum<
  typeof GlobalSearchResultStatuses
>
